(function() {
  'use strict';

  class ExperienceCenters {
    constructor(container) {
      this.container = container;
      this.currentTabIndex = 0;
      this.locationsPanelOpen = false;
      // Desktop map filter default; mobile list starts collapsed
      this.currentIconType = 'icon1';

      const activeTypeBtn = container.querySelector('.mt-experience-centers__type-btn--active');
      if (activeTypeBtn && activeTypeBtn.dataset.iconType) {
        this.currentIconType = activeTypeBtn.dataset.iconType;
      }

      this.init();
    }

    init() {
      this.setupTabButtons();
      this.setupTypeButtons();
      this.setupMobileLocationTabs();
      this.syncIconTypeAvailability();
      this.updateMobileLocationTabs();
      this.updateLocationsPanel();
      this.updateDisplay();
      window.addEventListener('resize', () => {
        this.syncIconTypeAvailability();
        this.updateLocationsList();
      });
    }

    getCurrentTabIconTypes() {
      const activeMapImage = this.container.querySelector(
        `.mt-experience-centers__map-image[data-tab-index="${this.currentTabIndex}"]`
      );
      if (!activeMapImage) return [];

      const raw = (activeMapImage.dataset.iconTypes || '').trim();
      if (!raw) return [];

      return raw
        .split('-')
        .map((type) => type.trim())
        .filter(Boolean);
    }

    syncIconTypeAvailability() {
      const availableTypes = this.getCurrentTabIconTypes();
      const mobileLocationTabs = this.container.querySelectorAll(
        '.mt-experience-centers__locations-tab-btn'
      );

      mobileLocationTabs.forEach((btn) => {
        const iconType = btn.dataset.iconType;
        const isAvailable = availableTypes.indexOf(iconType) !== -1;
        btn.classList.toggle('is-hidden', !isAvailable);
        btn.hidden = !isAvailable;
      });

      if (availableTypes.length && availableTypes.indexOf(this.currentIconType) === -1) {
        this.currentIconType =
          availableTypes.indexOf('icon1') !== -1 ? 'icon1' : availableTypes[0];
        this.updateTypeButtons();
      }

      // If current expanded type is no longer available, collapse panel
      if (
        this.locationsPanelOpen &&
        availableTypes.indexOf(this.currentIconType) === -1
      ) {
        this.locationsPanelOpen = false;
      }

      this.updateMobileLocationTabs();
      this.updateLocationsPanel();
    }

    setupTabButtons() {
      const tabButtons = this.container.querySelectorAll('.mt-experience-centers__tab-btn');
      tabButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
          this.currentTabIndex = index;
          // Switching region: collapse locations panel by default
          this.locationsPanelOpen = false;
          this.updateTabButtons();
          this.syncIconTypeAvailability();
          this.updateDisplay();
        });
      });
    }

    setupTypeButtons() {
      const typeButtons = this.container.querySelectorAll('.mt-experience-centers__type-btn');
      typeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.currentIconType = btn.dataset.iconType;
          this.updateTypeButtons();
          this.updateDisplay();
        });
      });
    }

    setupMobileLocationTabs() {
      const mobileLocationTabs = this.container.querySelectorAll(
        '.mt-experience-centers__locations-tab-btn'
      );
      mobileLocationTabs.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.hidden || btn.classList.contains('is-hidden')) return;

          const iconType = btn.dataset.iconType;

          // Same active tab while open → collapse; otherwise expand / switch
          if (this.locationsPanelOpen && this.currentIconType === iconType) {
            this.locationsPanelOpen = false;
          } else {
            this.locationsPanelOpen = true;
            this.currentIconType = iconType;
          }

          this.updateMobileLocationTabs();
          this.updateLocationsPanel();
          this.updateTypeButtons();
          this.updateDisplay();
        });
      });
    }

    updateTabButtons() {
      const tabButtons = this.container.querySelectorAll('.mt-experience-centers__tab-btn');
      tabButtons.forEach((btn, index) => {
        if (index === this.currentTabIndex) {
          btn.classList.add('mt-experience-centers__tab-btn--active');
        } else {
          btn.classList.remove('mt-experience-centers__tab-btn--active');
        }
      });
    }

    updateTypeButtons() {
      const typeButtons = this.container.querySelectorAll('.mt-experience-centers__type-btn');
      typeButtons.forEach((btn) => {
        if (btn.dataset.iconType === this.currentIconType) {
          btn.classList.add('mt-experience-centers__type-btn--active');
        } else {
          btn.classList.remove('mt-experience-centers__type-btn--active');
        }
      });
    }

    updateLocationsPanel() {
      const locations = this.container.querySelector('[data-mt-locations]');
      if (!locations) return;

      locations.classList.toggle('is-collapsed', !this.locationsPanelOpen);
    }

    updateDisplay() {
      const mapImages = this.container.querySelectorAll('.mt-experience-centers__map-image');
      mapImages.forEach((img, index) => {
        if (index === this.currentTabIndex) {
          img.classList.add('mt-experience-centers__map-image--active');
        } else {
          img.classList.remove('mt-experience-centers__map-image--active');
        }
      });

      const activeMapImage = this.container.querySelector(
        `.mt-experience-centers__map-image[data-tab-index="${this.currentTabIndex}"]`
      );
      if (activeMapImage) {
        const icons = activeMapImage.querySelectorAll('.mt-experience-centers__icon');
        icons.forEach((icon) => {
          if (icon.dataset.iconType === this.currentIconType) {
            icon.classList.add('mt-experience-centers__icon--visible');
          } else {
            icon.classList.remove('mt-experience-centers__icon--visible');
          }
        });
      }

      const inactiveMapImages = this.container.querySelectorAll(
        '.mt-experience-centers__map-image:not(.mt-experience-centers__map-image--active)'
      );
      inactiveMapImages.forEach((mapImage) => {
        mapImage.querySelectorAll('.mt-experience-centers__icon').forEach((icon) => {
          icon.classList.remove('mt-experience-centers__icon--visible');
        });
      });

      this.updateLocationsList();
    }

    updateMobileLocationTabs() {
      const mobileLocationTabs = this.container.querySelectorAll(
        '.mt-experience-centers__locations-tab-btn'
      );
      mobileLocationTabs.forEach((btn) => {
        const isActive =
          this.locationsPanelOpen && btn.dataset.iconType === this.currentIconType;
        btn.classList.toggle('mt-experience-centers__locations-tab-btn--active', isActive);
        btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    }

    updateLocationsList() {
      const locationItems = this.container.querySelectorAll(
        '.mt-experience-centers__location-item'
      );

      locationItems.forEach((item) => {
        const tabIndex = parseInt(item.dataset.tabIndex || -1, 10);
        const iconType = item.dataset.iconType;
        const shouldShow =
          this.locationsPanelOpen &&
          tabIndex === this.currentTabIndex &&
          iconType === this.currentIconType;

        item.classList.toggle('mt-experience-centers__location-item--visible', shouldShow);
      });
    }
  }

  function initAll() {
    const containers = document.querySelectorAll('.mt-experience-centers');
    containers.forEach((container) => {
      if (container.dataset.mtExperienceInitialized === 'true') return;
      container.dataset.mtExperienceInitialized = 'true';
      new ExperienceCenters(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.mt-experience-centers').forEach((container) => {
      container.dataset.mtExperienceInitialized = 'false';
    });
    initAll();
  });
})();
